module.exports = __webpack_public_path__ + "static/media/loading2.fec09f8a.gif";